import { ILocationPath, Location } from './location';
import { AmazonS3LinkedService } from '../../linkedservice/amazon-s3.linkedservice';
import { Metamodel } from '../../base/model';
import { IAttribute, IModel } from '../../base/annotation';
import { FilePath } from '../file-path';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'AmazonS3Location',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3LinkedService)
    }
})
/**
 * Note: According to the latest doc, only Amazon S3 support Preserve metadata.
 * Do not extend other S3 family from this class.
 */
export class AmazonS3Location extends Location {
    public static readonly MODEL: IModel;
    public static readonly CONTAINER: IAttribute;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_BucketName,
        association: 'CONTAINER',
        templatable: true
    })
    public container?: string;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', AmazonS3Location.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', AmazonS3Location.FILE_NAME, path);
        this.setPathPropertyValue('container', AmazonS3Location.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: AmazonS3Location.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: AmazonS3Location.FILE_NAME.templateValue(this) || this.fileName,
            container: AmazonS3Location.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && AmazonS3Location.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(AmazonS3Location.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(AmazonS3Location.FILE_NAME.templateValue(this));
    }
}
